import React from "react";
import ScrollableAnchor from "react-scrollable-anchor";

const RelaxSection = () => (
    <ScrollableAnchor id="relax">
      <section className="content-section bg-dark text-white text-center animatedParent animateOnce" data-sequence='500' data-appear-top-offset='-300'>
        <div className="container">
          <div className="content-section-heading text-center">
            <h3 className="text-secondary mb-0">Info</h3>
            <h2 className="mb-5">Entspannungskurse</h2>
          </div>
          <div className="animated fadeInDownShort" data-id="1" align="center">
            <p className="textJustify normalWidth">Die innere Stille für Körper und Geist soll mit Hilfe verschiedenster
              Möglichkeiten, in Form von:</p>
            <div className="textJustify normalWidth" align="center">
              <ul>
                <li>Audiogenestraining</li>
                <li>Progressiver Muskelrelaxion nach Jacopson (PMR)</li>
                <li>Meditations varianten</li>
                <ul><li>Qi Gong</li></ul>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </ScrollableAnchor>
);

export default RelaxSection;



// WEBPACK FOOTER //
// ./src/courseinfo/relax.js